var _rect, _rect2, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 225,
    fill: "#6C7C8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 126,
    width: 58,
    height: 58,
    fill: "black",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.268 47C296.038 45.6667 297.962 45.6667 298.732 47L329.909 101C330.679 102.333 329.717 104 328.177 104H265.823C264.283 104 263.321 102.333 264.091 101L295.268 47Z",
    fill: "black",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 155,
    r: 29,
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage600);
export default __webpack_public_path__ + "static/media/noImage600.bf1ef4ff7beba635d3818c73a85db739.svg";
export { ForwardRef as ReactComponent };